import React, {useState, useEffect, useRef} from 'react'
import firebase from "firebase";
import axios from "axios";
import Admin from "./Admin";


function AdminWrapper(
    {
        classLevel,
        handleClassLevel
    }
) {

    const [sideMenu, setSideMenu] = useState(false);
    const [databaseChoice, setDatabaseChoice] = useState('statistics');
    const [actionChoice, setActionChoice] = useState('add');
    const [mediaChoice, setMediaChoice] = useState('none');
    const [assignment, setAssignment] = useState('')

    const [authenticated, setAuthenticated] = useState(false);

    const [password, setPassword] = useState('');
    const [errMsg, setErrMsg] = useState('');
    const [email] = useState('uhadmin@hawaii.edu');
    const [studentData, setStudentData] = useState([]);
    let labels = ["Student", "/pronunciation", "/dialogConversation", "/translation", "/dialogFlashCard", "/quizzes"];
    const [students, setStudents] = useState([]);
    const [pronunciationViewCount, setPronunciationViewCount] = useState([]);
    const [dialogConversationViewCount, setDialogConversationViewCount] = useState([]);
    const [translationViewCount, setTranslationViewCount] = useState([]);
    const [dialogFlashCardViewCount, setDialogFlashCardViewCount] = useState([]);
    const [quizzesViewCount, setQuizzesViewCount] = useState([]);

    const [totalViewCount, setTotalViewCount] = useState([]);
    const [dates, setDates] = useState([]);
    const [todaysViews, setTodaysViews] = useState(0);

    useEffect(() => {
        const studentFile = firebase.storage().ref().child('students/studentData.json');
        studentFile.getDownloadURL()
            .then(url => axios.get(url))
            .then(res => {
                setStudentData(res.data);
                for (let i = 0; i < res.data.length; i++) {
                    students.push(res.data[i].user);
                    pronunciationViewCount.push(res.data[i].pronunciation);
                    dialogConversationViewCount.push(res.data[i].dialogConversation);
                    translationViewCount.push(res.data[i].translation);
                    dialogFlashCardViewCount.push(res.data[i].dialogFlashCard);
                    quizzesViewCount.push(res.data[i].quizzes);
                }
            });
        const studentViews = firebase.storage().ref().child('students/studentViews.json');
        studentViews.getDownloadURL()
            .then(url => axios.get(url))
            .then(res => {
                setStudentData(res.data);
                const dateArray = new Date().toString().split(' ');
                const todaysDate = dateArray[1] + "/" + dateArray[2] + "/" + dateArray[3];
                for (let i = 0; i < res.data.length; i++) {
                    setTotalViewCount(prevState => [...prevState, res.data[i].viewCount]);
                    setDates(prevState => [...prevState, res.data[i].date]);
                    if (todaysDate === res.data[i].date) {
                        setTodaysViews(res.data[i].viewCount);
                    }
                }

            });

    }, []);
    useEffect(() => {
        setAssignment('')
    },[databaseChoice, actionChoice, mediaChoice, classLevel]);


    const handleChange = (event) => {
        setPassword(event.target.value);
        setErrMsg('')
    };

    const submitPassword = () => {
        firebase.auth().signInWithEmailAndPassword(email, password).then(() => setAuthenticated(true)).catch(function (error) {
            setErrMsg(error.message);
        });
    };

    const handleSideMenu = () => {
        setSideMenu(!sideMenu)
    };

    const handleSetDatabaseChoice = (event, {value}) => {
        setDatabaseChoice(value)
    };

    const handleSetAction = (event, {value}) => {
        setActionChoice(value)
    };

    const handleSetMediaChoice = (event, {value}) => {
        setMediaChoice(value)
    };
    const handleSetAssignment = (event, {value}) => {
        setAssignment(value)
    };

    const closeSideMenu = () => {
        setSideMenu(false);
    };

    return (
        <>
            <Admin
                authenticated={authenticated}
                students={students}
                pronunciationViewCount={pronunciationViewCount}
                dialogConversationViewCount={dialogConversationViewCount}
                translationViewCount={translationViewCount}
                dialogFlashCardViewCount={dialogFlashCardViewCount}
                quizzesViewCount={quizzesViewCount}
                dates={dates}
                totalViewCount={totalViewCount}
                todaysViews={todaysViews}
                errMsg={errMsg}
                handleChange={handleChange}
                submitPassword={submitPassword}
                classLevel={classLevel}
                handleClassLevel={handleClassLevel}
                sideMenu={sideMenu}
                handleSideMenu={handleSideMenu}
                databaseChoice={databaseChoice}
                handleSetDatabaseChoice={handleSetDatabaseChoice}
                actionChoice={actionChoice}
                handleSetAction={handleSetAction}
                handleSetMediaChoice={handleSetMediaChoice}
                mediaChoice={mediaChoice}
                assignment={assignment}
                handleSetAssignment={handleSetAssignment}
                closeSideMenu={closeSideMenu}
                setAssignment={setAssignment}
            />
        </>
    )
}

export default AdminWrapper
